<script setup lang="ts">
import HeaderLoyaltyButton from '../loyalty/HeaderLoyaltyButton.vue';

const userStore = useUserStore();
</script>

<template>
  <nuxt-link
    v-if="Boolean(userStore.user)"
    to="/profile#projects"
    class="new-button new-button_sm new-button_transparent"
  >
    Мои заказы
  </nuxt-link>
  <nuxt-link
    to="/topics"
    class="new-button new-button_sm new-button_transparent"
  >
    Темы проектов
  </nuxt-link>

  <HeaderLoyaltyButton />
</template>
